import React from 'react'
import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage
} from '@chakra-ui/react'
import { Controller } from 'react-hook-form'

const EInput = ({ label, name, placeholder, control, style, labelStyle, controlStyle, errorStyle, ...rest}) => {
  return (
    <Controller
      control={control}
      name={name}
      {...rest}
      render={({ field, fieldState: { error } }) => (
        <FormControl isInvalid={!!error} sx={controlStyle}>
          {label && <FormLabel sx={labelStyle}>{label}</FormLabel>}
          <Input {...field} placeholder={placeholder} sx={style} fontSize={'14px'}/>
          <FormErrorMessage sx={errorStyle} fontSize={'14px'}>{error && error.message}</FormErrorMessage>
        </FormControl>
      )}
    />
  )
}

export default EInput
